import { FaArrowLeft, FaArrowRight, FaArrowsAltH, FaCar, FaShower, FaStar } from "react-icons/fa";
import { FiHome, FiBox, FiKey, FiFolder, FiUsers, FiUser, FiLock, FiCast } from "react-icons/fi";
import { IconType } from "react-icons";
import PersonPinCircleOutlinedIcon from '@mui/icons-material/PersonPinCircleOutlined';
import { AssetLocation, AssetLocationTypes } from "../../../logic/api";
import LocationNodeAttachment from "../attachments/LocationNodeAttachment";
import { ITreeViewNodeDesign, ITreeViewRecord } from "../TreeView";
import { ReleaseFlag, useReleaseManagement } from "../../../utility/feature-management";

export const LocationsTreeViewDesign = (record: ITreeViewRecord) => {
  const isCarWashLocationEnabled = useReleaseManagement(ReleaseFlag.releaseCarWashLocation);
  const isVipLocationEnabled = useReleaseManagement(ReleaseFlag.releaseVipLocation);
  const isMeetAndGreetTypeEnabled = useReleaseManagement(ReleaseFlag.releaseLocationMeetAndGreetType);

  const location = record as AssetLocation;
  const design: ITreeViewNodeDesign = {};

  if (location.type == AssetLocationTypes.CarPark) {
    design.icon = FiHome;
    design.colour = "#73B9FF";
  } else if (location.type == AssetLocationTypes.Zone) {
    if (isCarWashLocationEnabled && location.carWash) {
      design.icon = FaShower;
      design.colour = "#73B9FF";
    }
    else if (isVipLocationEnabled && location.vip) {
      design.icon = FaStar;
      design.colour = "orange";
    }
    else {
      design.icon = FiBox;
      design.colour = "#36D900";
    }
  } else if (location.type == AssetLocationTypes.Lane) {
    if (isMeetAndGreetTypeEnabled && (location.isCollectionPoint || location.isDeliveryPoint)) {
      design.icon = PersonPinCircleOutlinedIcon as unknown as IconType;
      design.colour = "#FF7373";
    } else if (isCarWashLocationEnabled && location.carWash) {
      design.icon = FaShower;
      design.colour = "#73B9FF";
    } else if (isVipLocationEnabled && location.vip) {
      design.icon = FaStar;
      design.colour = "orange";
    } else {
      const arrivalReturnType = getArrivalsReturnsIcon(location);
      if (arrivalReturnType) {
        design.icon = arrivalReturnType;
        design.colour = "#FF7373";
      } else if (location.blockPark == true) {
        design.icon = FaCar;
        design.colour = "brown";
      } else {
        design.icon = FiBox;
        design.colour = "#FFB973";
      }
    }
  } else if (location.type == AssetLocationTypes.Keyroom) {
    design.icon = FiKey;
    design.colour = "#B973FF";
  } else if (location.type == AssetLocationTypes.Hook) {
    design.icon = getArrivalsReturnsIcon(location) ?? FiKey
    design.colour = "#CFBFFF";
  } else if (location.type == AssetLocationTypes.KeyLocker) {
    design.icon = FiLock;
    design.colour = "#CFBFFF";
  } else if (location.type == AssetLocationTypes.KeyLockerBox) {
    design.icon = getArrivalsReturnsIcon(location) ?? FiCast;
    design.colour = "#CFBFFF";
    if (location.disabledByKiosk == true) {
      design.colour = "red";
    }
  } else if (location.type == AssetLocationTypes.Users) {
    design.icon = FiUsers;
    design.colour = "#FFCC99";
  } else if (location.type == AssetLocationTypes.User) {
    design.icon = FiUser;
    design.colour = "#FFCC99";
  } else if (location.type == AssetLocationTypes.DynamicBox) {
    design.icon = getArrivalsReturnsIcon(location) ?? FiCast;
    design.colour = "#B973FF";
  } else if (location.type === AssetLocationTypes.KeyBox) {
    design.icon = getArrivalsReturnsIcon(location) ?? FiFolder;
    design.colour = "#FF99FF";
  } else {
    design.icon = FiFolder;
    design.colour = "#FF99FF";
  }

  design.attachment = LocationNodeAttachment;

  return design;
}

const getArrivalsReturnsIcon = (location: AssetLocation): typeof FaArrowsAltH | null => {
  if (location.returns && location.arrivals) {
    return FaArrowsAltH;
  } else if (location.returns && !location.arrivals) {
    return FaArrowLeft;
  } else if (location.arrivals && !location.returns) {
    return FaArrowRight;
  }

  return null;
}
